import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
// Services
import { ViewsService } from '../../../../../../services/views.service';
import { ScrollableItemsHelperOsService } from '../../../../../services/scrollable-items-helper-os.service';
import { ExternalApiService } from '../../../../../services/external-api.service';
import { LayoutRenderService } from '../../../../services/layout-render.service';
import { RuleEngineStateService } from '../../../../../../rule-engine/rules/services';
import { BroadcastService } from '@cv-invision/core';
// Components
import { RoomLayoutBaseComponent } from '../../../common/room-layout/model/room-layout.base';
// Model
import { LayoutComponentBroadcast, LayoutRenderLayoutItem } from '../../../../models/cv-layout-render.model';
import { GeneralEventType } from '../../../models/component.events';
import { RULES_RUNNING_EVENT } from '../../../../../../rule-engine/rules/models';


@Component({
	selector: 'cv-schema-render-room40-layout',
	templateUrl: './room-layout.component.html',
	styleUrls: ['./room-layout.component.scss']
})
export class Room40LayoutComponent extends RoomLayoutBaseComponent implements OnInit, OnDestroy {
	// @Input() data: any;                                  // It being readed in the RoomLayoutBase
	// @Input() layoutNode = new LayoutRenderLayoutItem();  // It being readed in the RoomLayoutBase

	public layoutUIConfig: any = {};

	constructor(
		protected viewsService: ViewsService,
		protected scrollableHelper: ScrollableItemsHelperOsService,
		protected externalApi: ExternalApiService,
		protected layoutService: LayoutRenderService,
		protected ruleState: RuleEngineStateService,
		private broadcastService: BroadcastService,
	) {
		super(viewsService, scrollableHelper);

		this.layoutService.componentBroadcast
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcastData: LayoutComponentBroadcast) => {
				if (broadcastData.jsonPath === this.path) {
					switch (broadcastData.eventType) {
						case GeneralEventType.DATA_UPDATED:
							this.ruleState.SetIsRunningRules(true);
							this.externalApi.revalidateGSE(this.order.id).toPromise().then(({ defer, success }) => {
								if (defer === false && success === false) {
									this.broadcastService.broadcast({
										name: RULES_RUNNING_EVENT,
										event: {}
									});
								}
							});
							break;
					}
				}
			});
	}

	ngOnInit(): void {
		this.init();
		// Attach Layout Config
		this.layoutUIConfig = this.layoutService.layout;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
